import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from './ui';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà accepté les cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    
    // Si pas de consentement enregistré, afficher la bannière
    if (!cookieConsent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    // Enregistrer le consentement avec la date
    localStorage.setItem('cookieConsent', new Date().toISOString());
    setVisible(false);
  };

  const handleDecline = () => {
    // Enregistrer le refus (pour ne pas redemander constamment)
    localStorage.setItem('cookieConsent', 'declined');
    setVisible(false);
  };

  const handleCustomize = () => {
    // Rediriger vers la page de politique de cookies
    localStorage.setItem('cookieConsent', 'customized');
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="container mx-auto">
        <div className="flex flex-col items-center justify-between gap-4 rounded-card border border-white/[.08] bg-surface/95 p-4 backdrop-blur-md md:flex-row md:p-6">
          <div className="mb-0 flex-grow text-body md:mr-8">
            <h5 className="mb-2 text-base font-semibold text-body">{t('cookieBanner.title')}</h5>
            <p className="text-sm text-muted">
              {t('cookieBanner.body')}{' '}
              <Link to="/cookies" className="text-body underline underline-offset-2 hover:text-muted">
                {t('cookieBanner.policy')}
              </Link>
              .
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 md:w-auto w-full shrink-0">
            <Button variant="ghost" onClick={handleDecline} className="px-4 py-2 text-sm">
              {t('cookieBanner.decline')}
            </Button>
            <Button variant="secondary" onClick={handleCustomize} className="px-4 py-2 text-sm">
              {t('cookieBanner.customize')}
            </Button>
            <Button variant="primary" onClick={handleAccept} className="px-4 py-2 text-sm">
              {t('cookieBanner.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
